export default __webpack_public_path__ + "static/media/delete.116548b5.svg";